module.exports = window["redfoxThankYou"]["controlGroups"];